<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7PimQL/tc-custom/9781460322680.jpg?1728327053856" alt="This image is the cover for the book Not Just the Boss's Plaything & A Devil in Disguise"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Not Just the Boss's Plaything & A Devil in Disguise
      </h1>
      <p class="bookDescription body article font2">
        <p>Not Just the Boss's Plaything <br/><br/>A very personal performance plan  <br/><br/>From the moment Alicia Teller tripped and fell into Nikolai Korovin's arms, her iron-clad control started to slip! <br/><br/>While Alicia's tantalizing curves might drive Nikolai to distraction, business and pleasure are not two things this legendary tycoon has ever mixeduntil now. <br/><br/>A Devil in Disguise <br/><br/>Playing with fire! <br/><br/>Drusilla Bennett's job from hell will soon be over. Ready to take her life back, she plucks up the courage to say "I quit!" <br/><br/>But nothing and no one has ever taken Cayo Vila by surprise, and he's not going to let Dru go quite so easily!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Caitlin Crews
      </h2>
      
      <p class="authorDescription body article">Caitlin Crews discovered her first romance novel at the age of twelve and has since began her life-long love affair with romance novels, many of which she insists on keeping near her at all times. She currently lives in California, with her animator/comic book artist husband and their menagerie of ridiculous animals.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?81398dc0